// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const { BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER } = require('constants/index');

const getMorningStarInvestmentDataInProgress = () => ({
    type: actionTypes.GET_MORNING_STAR_INVESTMENT_DATA_IN_PROGRESS
});

const getMorningStarInvestmentDataSuccess = response => ({
    type: actionTypes.GET_MORNING_STAR_INVESTMENT_DATA_SUCCESS,
    payload: response
});

const getMorningStarInvestmentDataFailure = error => ({
    type: actionTypes.GET_MORNING_STAR_INVESTMENT_DATA_FAILURE,
    payload: {
        error
    }
});

const getMorningStarInvestmentData = (customInstitutionSecurityId) => (dispatch, getState) => {
    const immInvestmentFunds = getState().investmentFunds;
    if ( !immInvestmentFunds.get('fetchSuccess') && !immInvestmentFunds.get('isFetching') ){
        const typeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;

        const requestData = {
            query: {
                securityDataPoints:
                    'Name|Rating|ReturnM0|ReturnM12|ReturnM36|ReturnM60|CustomInstitutionSecurityId|CustomCategoryIdName',
                pageSize: 5000,
                outputType: 'json',
                languageId: 'es-ES',
                currencyId: 'EUR',
                universeIds: 'FOEUR$$ALL_2118',
                filters: `CustomInstitutionSecurityId:EQ:${customInstitutionSecurityId}`
            }
        };

        dispatch(getMorningStarInvestmentDataInProgress());
        return APIGet(
            dispatch,
            apiURLBuilder.getURL('brokerGetMorningStarScreener', { type: typeId }),
            requestData
        )
            .then(response => {
                try {
                    // If response.rows[0].Name fails we consider that MorningStar didn't find the investment fund
                    response.rows[0].Name &&
                        dispatch(getMorningStarInvestmentDataSuccess(response.rows[0]));
                } catch (error) {
                    dispatch(getMorningStarInvestmentDataFailure(error));
                }
            })
            .catch(response => {
                dispatch(getMorningStarInvestmentDataFailure(response.error));
            });
    }
};

module.exports = {
    getMorningStarInvestmentData
};
